import { ResidentialAddressEntity } from 'api/types/entity/client';
import { Maybe } from 'types/maybe';

import { ResidentialAddressFormValue } from '../../forms/residentialAddressForm';

import { parseAddressValue } from './parseAddressValue';

export const parseResidentialAddressValue = (
  address?: Maybe<ResidentialAddressEntity>
): ResidentialAddressFormValue => ({
  ...parseAddressValue(address),
  proofOfResidenceFiles: address?.proofOfResidenceFiles,
});
